import { Map } from 'immutable';
import actionTypes from '../../actions/actionTypes';
import config from '../../config.json'

const INIT_STATE = Map({
    activeItem: false,
    activeDetailsItem: false,
    activePerformance: false,
    performancePageOpen: false,
    activeItemIndex: 0,
    currentActiveSelection: '',
    displaySidebarLeft: false,
    displaySidebarRight: false,
    displaySidebarRightSecond: false,
    isMobile: Map({
        slidebarNav: false,
        slidebarLeft: false,
        slidebarRight: false,
        desktop: false
    }),
    browserWidth: null,
    activeMovieTimes: null,
    itemsToDisplay: 2
})

function getMovieItemLength(width, theme) {
    if (theme === 'Arthouse') {
        if(width > 1449) {
            return 5
        }
        if(width > 759) {
            return 3
        }
        if(width > 519) {
            return 2
        }
        else {
            return 1
        }
    } else {
        if(width > 2150) {
            return 9
        }
        if(width > 1449) {
            return 7
        }
        if(width > 999) {
            return 5
        }
        if(width > 759) {
            return 3
        }
        if(width > 519) {
            return 2
        }
        else {
            return 1
        }
    }
}

function setBrowserWidth(state, action) {
    const {theme, width} = action.payload
    const itemsToDisplay = getMovieItemLength(width, theme)

    const stateWithItemsToDisplay = state.set('itemsToDisplay', itemsToDisplay)
    return stateWithItemsToDisplay.set('browserWidth', width);
}

function setIsMobile(state, action) {
    const keysToSet = _.keys(config.breakpoints)
    const browserWidth = state.get('browserWidth')
    const isMobile = {}

    keysToSet.forEach(key => {
        const breakpointReached = browserWidth > config.breakpoints[key] ? false : true
        return isMobile[key] = breakpointReached
    })

    return state.set('isMobile', isMobile)
}

 function togglePerformancePage(state, action) {
    const {activePerformance, bool} = action.payload
    const activeItem = state.get('activeItem')

    const stateWithActivePerformance = state.set('activePerformance', activePerformance)
    let stateWithActiveItem = stateWithActivePerformance

    if(!activeItem) {
        stateWithActiveItem = stateWithActivePerformance.set('activeItem', activePerformance.movieId)
    } else if(activeItem && bool === false && !state.get('displaySidebarRight')) {
        stateWithActiveItem = stateWithActivePerformance.set('activeItem', false)
    }

    return stateWithActiveItem.set('performancePageOpen', bool).set('activeMovieTimes', stateWithActiveItem.get('activeItem'))
}

function toggleSidebars(state, action) {
    const {side, int, bool} = action.payload
    let key = 'displaySidebarLeft'

    if(side === 'right') {
        key = int === 1 ? 'displaySidebarRight' : 'displaySidebarRightSecond'
    }

    return state.set(key, bool)
}

function setActiveItemIndex(state, action) {
    const {index} = action.payload

    return state.set('activeItemIndex', index)
}

function toggleInformation(state, action) {
    const {id, movieTimesId} = action.payload

    const stateWithActiveItemSet = state.set('activeItem', id)
    return stateWithActiveItemSet.set('activeMovieTimes', movieTimesId)
}

function toggleDetails(state, action) {
    const {id} = action.payload
    return state.set('activeDetailsItem', id)
}

function setActiveSelection(state, action) {
    const {selectionId} = action.payload

    return state.set('currentActiveSelection', selectionId);
}

export default function elementDisplayReducer(state = INIT_STATE, action) {
    if(action === undefined){
        return state;
    }

    switch(action.type){
        case actionTypes.UI_SET_MOVIE_INFORMATION:
            return toggleInformation(state, action);
        case actionTypes.UI_SET_MOVIE_DETAILS:
            return toggleDetails(state, action);
        case actionTypes.UI_SET_MOVIE_PERFORMANCE_PAGE:
            return togglePerformancePage(state, action);
        case actionTypes.UI_SET_ACTIVE_SELECTION:
            return setActiveSelection(state, action);
        case actionTypes.UI_SET_ACTIVE_ITEM_INDEX:
            return setActiveItemIndex(state, action);
        case actionTypes.UI_SET_ISMOBILE:
            return setIsMobile(state, action);
        case actionTypes.UI_SET_BROWSER_WIDTH:
            return setBrowserWidth(state, action);
        case actionTypes.UI_TOGGLE_SIDEBARS:
            return toggleSidebars(state, action);
        default:
            return state;
    }
}